import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { generateStockAlerts, getNotifications, getUnreadCount, markAllAsRead, dismissNotification } from "../data/notifications";

const adminNavItems = [
  { to: "/Pilotage", icon: "fas fa-chart-line", label: "Pilotage", roles: ["admin", "cashier"] },
  { to: "/MyAccountCashier", icon: "fas fa-cash-register", label: "Caisse", roles: ["admin", "cashier"] },
  { to: "/MyAccountAddress", icon: "fas fa-box-open", label: "Catalogue", roles: ["admin", "cashier"] },
  { to: "/MyAccountSignUp", icon: "fas fa-user-plus", label: "Cashiers", roles: ["admin"] },
  { to: "/MyAcconutNotification", icon: "fas fa-warehouse", label: "Stock", roles: ["admin", "cashier"] },
  { to: "/MyAcconutPaymentMethod", icon: "fas fa-receipt", label: "Commandes", roles: ["admin", "cashier"] },
  { to: "/MyAccountCustomers", icon: "fas fa-users", label: "Clients", roles: ["admin"] },
  { to: "/MyAccountSuppliers", icon: "fas fa-truck", label: "Fournisseurs", roles: ["admin"] },
  { to: "/MyAccountB2B", icon: "fas fa-briefcase", label: "Ventes Pro B2B", roles: ["admin"] },
  { to: "/MyAccountEtiquettes", icon: "fas fa-barcode", label: "Étiquettes", roles: ["admin", "cashier"] },
  { to: "/MyAccountSetting", icon: "fas fa-cog", label: "Parametres", roles: ["admin"] },
];

const AdminSidebar = ({ activePath }) => {
  const { profile, signOut } = useAuth();
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [showNotifs, setShowNotifs] = useState(false);

  useEffect(() => {
    generateStockAlerts().then((all) => {
      setNotifications(all.slice(0, 20));
      setUnreadCount(all.filter((n) => !n.read).length);
    });
  }, []);

  const visibleNavItems = adminNavItems; // Bypass roles filter temporarily

  const renderLinks = () => (
    <ul className="nav flex-column nav-pills nav-pills-dark">
      {profile ? (
        <li className="nav-item mb-3 position-relative">
          <div className="px-3 py-2 bg-light rounded-3 d-flex justify-content-between align-items-center">
            <div>
              <div className="fw-semibold text-truncate" style={{ maxWidth: "120px" }}>{profile.full_name || "Compte admin"}</div>
              <small className="text-muted text-uppercase">{profile.role}</small>
            </div>
            <div>
              <button
                type="button"
                className="btn btn-sm position-relative"
                style={{ background: "transparent", border: "none", fontSize: "1.1rem" }}
                onClick={() => setShowNotifs(!showNotifs)}
              >
                <i className="fas fa-bell" />
                {unreadCount > 0 && (
                  <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger" style={{ fontSize: "0.65rem" }}>
                    {unreadCount}
                  </span>
                )}
              </button>
            </div>
          </div>
          {showNotifs && (
            <div
              className="position-absolute start-0 w-100 mt-2 bg-white border rounded-3 shadow-lg p-0"
              style={{ maxHeight: "400px", overflowY: "auto", zIndex: 9999 }}
            >
              <div className="d-flex justify-content-between align-items-center px-3 py-2 border-bottom">
                <strong style={{ fontSize: "0.85rem" }}>Alertes stock</strong>
                    {unreadCount > 0 && (
                      <button
                        type="button"
                        className="btn btn-sm btn-link p-0"
                        style={{ fontSize: "0.75rem" }}
                        onClick={async () => {
                          const updated = await markAllAsRead();
                          setNotifications(updated.slice(0, 20));
                          setUnreadCount(0);
                        }}
                      >
                        Tout marquer lu
                      </button>
                    )}
                  </div>
                  {!notifications.length ? (
                    <div className="text-center text-muted py-4" style={{ fontSize: "0.85rem" }}>
                      Aucune alerte en cours.
                    </div>
                  ) : (
                    notifications.slice(0, 10).map((n) => (
                      <div
                        key={n.id}
                        className={`d-flex justify-content-between align-items-start px-3 py-2 border-bottom ${!n.read ? "bg-light" : ""}`}
                        style={{ fontSize: "0.82rem" }}
                      >
                        <div className="flex-grow-1">
                          <div className={`fw-semibold ${n.severity === "danger" ? "text-danger" : n.severity === "critical" ? "text-warning" : "text-dark"}`}>
                            {n.title}
                          </div>
                          <small className="text-muted">{n.message.slice(0, 60)}{n.message.length > 60 ? "..." : ""}</small>
                        </div>
                        <button
                          type="button"
                          className="btn btn-sm p-0 ms-2"
                          style={{ fontSize: "0.7rem" }}
                          onClick={async () => {
                            const updated = await dismissNotification(n.id);
                            setNotifications(updated.slice(0, 20));
                            setUnreadCount(updated.filter((x) => !x.read).length);
                          }}
                        >
                          <i className="fas fa-times text-muted" />
                        </button>
                      </div>
                    ))
                  )}
                  <div className="px-3 py-2 text-center border-top">
                    <Link
                      to="/MyAcconutNotification"
                      className="btn btn-sm btn-outline-dark w-100"
                      onClick={() => setShowNotifs(false)}
                    >
                      Voir tout le stock
                    </Link>
                  </div>
                </div>
              )}
        </li>
      ) : null}
      {visibleNavItems.map((item) => (
        <li className="nav-item" key={item.to}>
          <Link
            className={`nav-link ${activePath === item.to ? "active" : ""}`}
            to={item.to}
          >
            <i className={`${item.icon} me-2`} />
            {item.label}
          </Link>
        </li>
      ))}
      <li className="nav-item">
        <hr />
      </li>
      <li className="nav-item">
        <button className="nav-link btn btn-link text-start w-100" type="button" onClick={signOut}>
          <i className="fas fa-right-from-bracket me-2" />
          Deconnexion
        </button>
      </li>
      <li className="nav-item">
        <Link className="nav-link" to="/">
          <i className="fas fa-sign-out-alt me-2" />
          Retour au site
        </Link>
      </li>
    </ul>
  );

  return (
    <>
      <div className="col-12">
        <div className="p-6 d-flex justify-content-between align-items-center d-md-none">
          <h3 className="fs-5 mb-0">Administration Almoune</h3>
          <button
            className="btn btn-outline-gray-400 text-muted d-md-none"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasAdmin"
            aria-controls="offcanvasAdmin"
          >
            <i className="fas fa-bars"></i>
          </button>
        </div>
      </div>

      <div className="col-lg-3 col-md-4 col-12 border-end d-none d-md-block">
        <div className="pt-10 pe-lg-10">{renderLinks()}</div>
      </div>

      <div
        className="offcanvas offcanvas-start"
        tabIndex={-1}
        id="offcanvasAdmin"
        aria-labelledby="offcanvasAdminLabel"
      >
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="offcanvasAdminLabel">
            Administration Almoune
          </h5>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          />
        </div>
        <div className="offcanvas-body">{renderLinks()}</div>
      </div>
    </>
  );
};

export default AdminSidebar;

